import * as bootstrap from "bootstrap"

//---- Bootstrap initialization
window.addEventListener("turbo:load", function(event) {
  const carouselContainer = document.querySelector('#carouselwoonsaem');
  if (carouselContainer) {
    const carousel = new bootstrap.Carousel(carouselContainer);
  }
});